import { HealthTeam } from "@/@types/esus/HealthTeam";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { Vaccination } from "@/@types/esus/Vaccination";
import { PaginationFilter } from "@/@types/generics/genericals";
import { Paginated } from "@/@types/generics/paginated";
import { esusApi } from "@/services/api";
import { IndicatorEsfStatusEnum } from "@/utils/enums/IndicatorEsfStatusEnum";

export type DetailedCitizensVaccinationsIndicatorC7Params = Partial<PaginationFilter> & {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	search: string;
	ine?: string;
	isEvaluated?: boolean;
	export?: boolean;
};

export class DetailedCitizenVaccinationsIndicatorC7Data {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	healthUnitId: number = 0;
	healthTeamId: number = 0;
	healthUnit?: HealthUnit;
	healthTeam?: HealthTeam;
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	vaccines?: Vaccination[];
	vaccinationStatus: IndicatorEsfStatusEnum = IndicatorEsfStatusEnum.Lost;
}

export async function getDetailedCitizensVaccinationsIndicatorC7({
	uf,
	ibgeCode,
	...params
}: DetailedCitizensVaccinationsIndicatorC7Params) {
	const response = await esusApi.get<Paginated<DetailedCitizenVaccinationsIndicatorC7Data>>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esf/c7/detailed-citizens-vaccinations`,
		params
	);
	return response.data ?? new Paginated<DetailedCitizenVaccinationsIndicatorC7Data>();
}
